import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TranslationProvider } from "./context/TranslationContext";
import HomePage from "./pages/HomePage";
import BioPage from "./pages/BioPage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import NoteTurnerPage from "./pages/NoteTurnerPage";
import ToneRegistryPage from "./pages/ToneRegistryPage";
import ContactPage from "./pages/ContactPage";
import MusicPage from "./pages/MusicPage";
import GalleryPage from "./pages/GalleryPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import LessonsPage from "./pages/LessonsPage";
import MuteClipPage from "./pages/MuteClipPage";
import BelloFlexPage from "./pages/BelloFlexPage";
import BrassPlankPage from "./pages/BrassPlankPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import RefundPage from "./pages/RefundPage";
import StudioPage from "./pages/StudioPage";
import WixProductRedirect from "./pages/WixProductRedirect";
import FAQPage from "./pages/FAQPage";
import DistributorsPage from "./pages/DistributorsPage";
import ForScorePage from "./pages/ForScorePage";
import MobileSheetsPage from "./pages/MobileSheetsPage";
import MyDownloadsPage from "./pages/MyDownloadsPage";
import ArrangementsPage from "./pages/ArrangementsPage";
import NotFoundPage from "./pages/NotFoundPage";
import CheckoutPage from "./pages/CheckoutPage";
import PayOrderPage from "./pages/PayOrderPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/CartDrawer";
import WhatsAppButton from "./components/WhatsAppButton";
import HolidayBanner from "./components/HolidayBanner";
import FreeShippingBanner from "./components/FreeShippingBanner";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "./utils/attribution";

// Hide the WhatsApp button on admin pages so it doesn't get in Isaías's way
// when he's managing orders.
function MaybeWhatsAppButton() {
  var loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  return <WhatsAppButton />;
}

// Hide the holiday banner on admin pages (Isaías doesn't need to see it).
function MaybeHolidayBanner() {
  var loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  return <HolidayBanner />;
}

// Same for the manual FREE SHIPPING campaign banner.
function MaybeFreeShippingBanner() {
  var loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  return <FreeShippingBanner />;
}

function App() {
  // Remember where this visitor arrived from, once, on their first page.
  captureAttribution();
  return (
    <div className="App">
      <TranslationProvider>
        <CartProvider>
        <BrowserRouter>
          <MaybeHolidayBanner />
          <MaybeFreeShippingBanner />
          <CartDrawer />
          <MaybeWhatsAppButton />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bio" element={<BioPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/noteturner" element={<NoteTurnerPage />} />
            <Route path="/toneregistry" element={<ToneRegistryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/lessons" element={<LessonsPage />} />
            <Route path="/muteclip" element={<MuteClipPage />} />
            <Route path="/belloflex" element={<BelloFlexPage />} />
            <Route path="/brass-plank" element={<BrassPlankPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/pay/:orderNumber" element={<PayOrderPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/distributors" element={<DistributorsPage />} />
            <Route path="/forscore" element={<ForScorePage />} />
            <Route path="/mobilesheets" element={<MobileSheetsPage />} />
            <Route path="/my-downloads" element={<MyDownloadsPage />} />
            <Route path="/arrangements" element={<ArrangementsPage />} />
            <Route path="/product-page/*" element={<WixProductRedirect />} />
            <Route path="/studio/*" element={<StudioPage />} />
            <Route path="/product" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        </CartProvider>
      </TranslationProvider>
    </div>
  );
}

export default App;
